export const mepRef33Options = [
  'friends-family-stronger',
  'friends-family-outside',
  'shops-restaurants-outside',
  'evacuation-centre',
  'other-safe-place',
  'other',
] as const;

export const mepRef33OptionLabels: Record<(typeof mepRef33Options)[number], string> = {
  'friends-family-stronger': 'Friends or family in a stronger building',
  'friends-family-outside': 'Friends or family outside the warning area',
  'shops-restaurants-outside': 'Shops, restaurants or other facilities outside the warning area',
  'evacuation-centre': 'Evacuation centre if available',
  'other-safe-place': 'Other safer place',
  other: 'Other',
} as const;
